import { ConsoleProvider, createLogger } from '@getcreatr/logger';

/**
 * Centralized logger instance for the frontend
 * Uses Console provider for logging
 *
 * Usage:
 *   import { logger } from '@/lib/logger';
 *
 *   logger.info('User logged in', { userId: 123 });
 *   logger.error('API call failed', { endpoint: '/api/users', status: 500 });
 *
 */
export const logger = createLogger({
  provider: new ConsoleProvider({
    isDevelopment: process.env.NODE_ENV === 'development',
    logSpans: false, // Disable span logging to reduce console noise
  }),
  environment: process.env.NEXT_PUBLIC_NODE_ENV,
  enabled: true,
});
